const getFacilityFax = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Contact'] && facility['Company Contact'].ID) {
    return facility['Company Contact'].Fax;
  }
  return null;
};

export default getFacilityFax;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityFax.js